<script>
  import katexify from "../katexify";
  import { tooltip } from "../tooltip";
</script>

<section>
  <p class="body-text">
    Machine Learning models learn to make predictions by looking at data with
    the help of algorithms, both of which can potentially be biased against
    different groups of people. Unwanted bias in machine learning can
    inadvertently harm, and negatively stereotype against underrepresented or
    (historically and otherwise) disfavored groups. Therefore, it is crucial to <span
      class="highlight"
      >evaluate and control data and model predictions not only for general machine
      learning performance but also for bias</span
    >.
  </p>
</section>
